import React from "react";

// 풀스크린 부트 화면 — 홈/로그인과 동일한 클린 시스템.
// 밝은 캔버스(#F6F7F8) 위 워드마크 + 가는 진행 바 하나.
const SANS =
  '"IBM Plex Sans KR", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
const DISPLAY = '"Archivo", "IBM Plex Sans KR", -apple-system, sans-serif';

const Loading = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "#F6F7F8",
      color: "#171A1E",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 20,
      zIndex: 9999,
      fontFamily: SANS,
    }}
  >
    {/* 워드마크 */}
    <div
      style={{
        fontFamily: DISPLAY,
        fontWeight: 800,
        fontSize: 28,
        lineHeight: 1,
        letterSpacing: "-0.01em",
        color: "#171A1E",
      }}
    >
      MARS<span style={{ color: "#E2451C" }}>.</span>
    </div>

    {/* 진행 바 */}
    <div
      style={{
        width: 160,
        height: 4,
        borderRadius: 2,
        backgroundColor: "#E4E7EA",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "40%",
          borderRadius: 2,
          backgroundColor: "#E2451C",
          animation: "marsLoadBar 1.1s linear infinite",
        }}
      />
    </div>

    <div style={{ fontFamily: SANS, fontSize: 13, color: "#6B7178" }}>
      불러오는 중…
    </div>

    <style>
      {`@keyframes marsLoadBar {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(250%); }
        }`}
    </style>
  </div>
);

export default Loading;
